import * as CONSTS from "../../assets/consts";
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import PropTypes from "prop-types";

const axios = require("axios").default;

export default function AppLog(
  httpClient = axios.create(),
  serverUrl = "",
  message = "",
  level = "ERROR",
  code = 0
) {
  // console.log(`httpClient`, httpClient, serverUrl, message, level, code);
  if (message) {
    //console.log(`message in AppLog`, message);
    try {
      var log = {
        message,
        level,
        code,
        clientInfo: `[mobile client]`,
      };
      var apiUrl = serverUrl;
      if (!apiUrl.endsWith("/")) apiUrl += "/";
      apiUrl += "Log/set";

      // console.log(`submit log to `, apiUrl, log);

      httpClient.post(apiUrl, log)
      .then(e => {
        return e.status
      })
      .catch((e) => {
        console.log(`error. failed to submit log to `, apiUrl , log, e);
      });
    } catch (error) {
      //console.log(`error. failed to submit log to `, apiUrl, error);
    }
  }
}
